import definitions from "../../definitions";
import ActorCampfire from "./ActorCampfire";
import ActorMoleEntrance from "./ActorMoleEntrance";
import ActorPipeVertical from "./ActorPipeVertical";
import ActorPipeHorizontal from "./ActorPipeHorizontal";
import ActorPortcullis from "./ActorPortcullis";

export default class ActorFactory {
    /**
     * @param {string} id
     * @returns {Actor}
     */
    static create(id) {
        switch (id) {
            case definitions.ACTOR_ID.CAMPFIRE: {
                return new ActorCampfire();
            }
            case definitions.ACTOR_ID.PIPE_ENTRANCE_VERTICAL: {
                return new ActorPipeVertical();
            }
            case definitions.ACTOR_ID.PIPE_ENTRANCE_HORIZONTAL: {
                return new ActorPipeHorizontal();
            }
            case definitions.ACTOR_ID.PORTCULLIS: {
                return new ActorPortcullis();
            }
            case definitions.ACTOR_ID.MOLE_ENTRANCE: {
                return new ActorMoleEntrance();
            }
        }
        return null;
    }
}